<template>
    <div>
        <Navigation :route="navigationRoute"></Navigation>
        <div>
            <div class="paper-item"  v-for="(e, i) in tableData.records" :key="i">
            </div>
            <el-button type="warning" size="mini" @click="applyhs" class="mt-20 mb-20" >申请学时</el-button>  
        </div>
            <el-table
                :data="tableData.records"
                border
                :header-cell-style="tableHeaderStyle"
                style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号"
                    width="50" align="center">
                    </el-table-column>
                <el-table-column
                    prop="xmName"
                    label="培训班" align="center" show-overflow-tooltip>
                    </el-table-column>
                <el-table-column
                    prop="orgName"
                    label="主办单位" align="center" show-overflow-tooltip>
                    </el-table-column>
                <el-table-column
                    prop="address"
                    label="培训时间"
                    width="190" align="center">
                   
                    <template slot-scope="scope">
                        <span >{{ scope.row.xmStartTime |dateFormat('yyyy-MM-dd') }}-{{ scope.row.xmEndTime|dateFormat('yyyy-MM-dd') }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="hours"
                    label="学时" align="center">
                    </el-table-column>
                <el-table-column
                    prop="address"
                    label="证明材料" align="center">
                    <template slot-scope="scope">
                        <a class="cRed" :href="scope.row.fileUrl" target="_blank">{{scope.row.fileName}}</a>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="status"
                    label="状态" align="center">
                    <template slot-scope="scope">
                        <span class="cWarning" v-if="scope.row.status==1||scope.row.status==2">{{toStr(scope.row.status)|f('hoursApplyStatus')}}</span>
                        <span class="cGreed" v-if="scope.row.status==3">{{toStr(scope.row.status)|f('hoursApplyStatus')}}</span>
                        <span class="cRed" v-if="scope.row.status==-1||scope.row.status==-2">{{toStr(scope.row.status)|f('hoursApplyStatus')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="remark" show-overflow-tooltip
                label="审核意见" align="center" width="100">
                </el-table-column>
                <el-table-column
                prop="applyTime"
                label="申请时间" align="center" width="160">
                </el-table-column>
            </el-table>
        <el-pagination @current-change="handleCurrentChange" background :current-page.sync="query.current"
            :page-size="10" layout="prev, pager, next, jumper" :total="tableData.total">
        </el-pagination>
    <applyhs ref="applyhs" @saveOk="getList()"></applyhs>
</div>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import { list, apply } from "@/api/statistics.js";
import { mapState, mapMutations } from "vuex";
import applyhs from "./applyhs.vue";

export default {
    name: "",
    components: {
        Navigation,
        applyhs
    },
    data() {
        return {
            navigationRoute: [
                { name: '学时统计' },
                { name: '学时补录' },
            ],
            query: {
                current: 1,
                size: 10
            },
            tableData: { //表格数据
                total: 0,
                records: []
            }
        };
    },
    created() {
        this.getList()
    },
    computed: {

    },
    methods: {
        tableHeaderStyle(){
            return 'background-color: #EEEEEE; '; //蓝色
        },
        handleCurrentChange(val) {
            this.query.current = val
            this.getList()
        },
        getList(pageNumber, pageSize) {
            
            this.query.current = pageNumber || this.query.current
            this.query.size = pageSize || this.query.size
            list(this.query).then(res => {
                this.tableData = res
            })
        },
        applyhs(){
            apply
            this.$refs.applyhs.open()
        },
        toStr(s){
            if(s){
                return s+''
            }else{
                return s
            }
        }
    },
};
</script>
<style lang="scss" scoped>

</style>